export const ContentTypeEnum = Object.freeze({
    Content: 1,
    Article: 2,
    Biblio: 3
});

export default ContentTypeEnum;